import React from 'react';
import PropTypes from 'prop-types';

const ModalBody = ({ children }) => (
  <div className="modal-body">
    {children}
  </div>
);

ModalBody.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
};

export default ModalBody;



// WEBPACK FOOTER //
// ./library/app/components/Global/Modals/ModalBody.js